export default __webpack_public_path__ + "static/media/me.2a9285b5.jpeg";